import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SpaContext } from '../Classes/spacontext';
import { ApiResponse, VisibaApiHttp } from '../Classes/visibaHttp.class';
import { Helper } from '../Common/Helpers/helper';
import { RR_SessionOutcome } from '../Common/Models/Api/Models/RR_SessionOutcome';

export type MedicalCoreOutcome =
	| 'solved-by-messaging'
	| 'called-the-patient'
	| 'referral-to-video'
	| 'referral-to-physical'
	| 'self-care'
	| 'new-remote-appointment'
	| 'new-local-appointment'
	| 'recipe'
	| 'test'
	| 'proof-of-sickness'
	| 'custom'
	| 'solved-during-consultation'
	| 'referral-digital-competence'
	| 'referral-emergency-treatment'
	| 'referral-physiotherapist'
	| 'referral-specialty-care'
	| 'other';

export interface PerformerFeedback {
	session_id: string;
	diagnosis_icd10s: string[];
	outcomes?: MedicalCoreOutcome[];
	urgency_ok: boolean | null;
	urgency_revision: number | null;
	selfcare_recommendation: boolean | null;
	other_outcome: string | null;
}

interface RepresentativeNinResponse {
	RepresentativeNin: string | null;
}

interface RedRobinSessionApiModel {
	SessionId: string;
	RepresentativeNin: string | null;
	InitialSymptoms: string[] | null;
}

@Injectable()
export class RedRobinService {
	constructor(private http: HttpClient, private visibaHttp: VisibaApiHttp, private helper: Helper, private spaContext: SpaContext) {}

	public getSessionOutcome(sessionId: string): Observable<RR_SessionOutcome> {
		return this.http.get<RR_SessionOutcome>(
			`${this.helper.rr.getApiRoot()}/sessions/${this.spaContext.unitConfig.LicenceHolder.GlobalCustomerId}/${sessionId}/outcome`,
		);
	}

	public getRepresentativeNin(sessionId: string): Observable<ApiResponse<RepresentativeNinResponse>> {
		return this.visibaHttp.getTyped<RepresentativeNinResponse>(`/Api/General/RedRobin/${sessionId}/GetRepresentativeNin`);
	}

	public getSession(sessionId: string): Observable<ApiResponse<RedRobinSessionApiModel>> {
		return this.visibaHttp.getTyped<RedRobinSessionApiModel>(`/Api/General/RedRobin/${sessionId}`);
	}

	public setPerformerFeedback(sessionId: string, feedback: PerformerFeedback): Observable<unknown> {
		// Because of the difference between how the GUID is represented by our backend and
		// the AI-backend, we need to trim away all the hyphens
		return this.http.post(
			`${this.helper.rr.getApiRoot()}/sessions/${sessionId.replace(/-/g, '')}/proxy/sessions/hcp_feedback`,
			feedback,
			{
				withCredentials: false,
				headers: undefined,
			},
		);
	}
}
